var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
import { useOrdersAsync } from '../../../..';
import { useAPIContext } from '../../../../components/Context';
import { useCallbackRef } from '../../../../utils';
import { createAsyncState } from '../hooks';
var useCancelAsync = createAsyncState('cancel');
export var useCancelRequest = function (orderID) {
    var cancel = useAPIContext().cancel;
    var _a = useCancelAsync(orderID), asyncState = _a[0], _b = _a[1], reset = _b.reset, start = _b.start, success = _b.success, error = _b.error;
    var _c = useOrdersAsync(), data = _c[0].data, ordersSuccess = _c[1].success;
    var _d = useState(), body = _d[0], setBody = _d[1];
    var cancelHandler = useCallbackRef(function () { return setBody({
        orderid: orderID,
    }); });
    var successHandler = useCallbackRef(function (response) {
        var orders = data === null || data === void 0 ? void 0 : data.orders;
        success(response);
        // как только заказ успешно отменен,
        // нужно остановить поллинг сменив статус на статус из ответа
        if (orders && orders.length > 0 && 'status' in response) {
            ordersSuccess({
                orders: orders.map(function (o) { return o.orderid === orderID
                    ? __assign(__assign({}, o), { status: response.status }) : o; }),
            });
        }
    });
    useEffect(function () {
        if (cancel && body) {
            start();
            return cancel({
                body: body,
                onError: error,
                onSuccess: successHandler,
            });
        }
    }, [body, cancel, error, start, successHandler]);
    useEffect(function () { return reset; }, [reset]);
    return [cancelHandler, asyncState];
};
